import { render, staticRenderFns } from "./LexinKeyboardLangContent.vue?vue&type=template&id=4606e0c6&"
import script from "./LexinKeyboardLangContent.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports